export const TIME_SLOTS = ["11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM"];

export const FRIDAY_ARRIVAL_SLOTS = ["6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM"];

export function isFriday(date) {
  return date.getDay() === 5;
}

export function isOpenDay(date) {
  const day = date.getDay();
  if (day >= 4 && day <= 6) return true; // Thu, Fri, Sat
  if (day === 0 && date.getDate() <= 7) return true; // 1st Sunday
  return false;
}

export function toLocalDateStr(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;
}

export function fmtDate(d) {
  const date = typeof d === "string" ? new Date(d + "T00:00:00") : d;
  return date.toLocaleDateString("en-AU", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
